import Vue from 'vue';
import cronstrue from 'cronstrue';
import Item from '../marketplace/item';

function Poll(config) {
    if (!(this instanceof Poll)) {
		return new Poll(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

Poll.prototype = {
	constructor: Poll,

	id: '',
    name: '',
    type: 'POLL',
	state: '',
	processing: false,
    method: '',
    uri: '',
    cron: '',
    qs: null,
    headers: null,
    from: null,
    createdOn: null,
    bucketKey: '',
    accessKey: '',
    values: {},
    secretsOptions: {},
    iotBucketId: null,
    iotBucketName: null,
    marketItem: null,
    selectedSignals: [],
    credits: null
};

Poll.fromDTO = function (dto) {
    if (dto === null || dto === undefined) {
		return null;
    }

	return new Poll({
        id: dto.id,
        accessKey: dto.accessKey,
        bucketKey: dto.bucketKey,
        createdOn: dto.createdOn,
        cron: dto.cron,
        from: dto.from,
        headers: dto.headers,
        method: dto.method,
        name: dto.name,
        qs: dto.qs,
		state: dto.state,
        uri: dto.uri,
        values: dto.values,
        secretsOptions: dto.secretsOptions,
        selectedSignals: dto.selectedSignals,
        credits: dto.credits,
        marketItem: dto.marketItem ? new Item(dto.marketItem) : null,
	});
};

Poll.prototype.isActive = function () {
    return this.state === 'ACTIVE';
};

Poll.prototype.isInactive = function () {
    return this.state === 'INACTIVE';
};

Poll.prototype.isArchived = function () {
    return this.state === 'ARCHIVED';
};

Poll.prototype.cronReadable = function () {
    try {
        if(this.cron === '0 0 * * *') {
            return 'Daily';
        }
        return cronstrue.toString(this.cron);
    } catch (e) {
        return null;
    }
};

export default Poll;



// WEBPACK FOOTER //
// ./src/modules/polls/poll.js